import { C, SERIF, SANS, PAGE_W, PAGE_H } from "./theme";
import { LogoLight } from "./ReportChrome";
import { gbp } from "./reportUtils";

export default function CoverPage({ pageRef, host, address, cityName, bedrooms, guests, netTotal, avgMonth, dateStr, refCode }) {
  return (
    <div ref={pageRef} style={{ width: PAGE_W, height: PAGE_H, background: C.evergreen, color: "#fff", position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "56px 64px 0" }}>
        <LogoLight height={24} />
        <span style={{ fontFamily: SANS, fontSize: 9.5, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.5)" }}>Revenue estimate</span>
      </div>

      <div style={{ padding: "0 64px", marginTop: "auto" }}>
        <div style={{ fontFamily: SANS, fontSize: 9.5, fontWeight: 600, letterSpacing: "0.14em", textTransform: "uppercase", color: C.tea }}>
          Prepared for {host}
        </div>
        <h1 style={{ fontFamily: SERIF, fontWeight: 400, fontSize: 50, lineHeight: 1.04, letterSpacing: "-0.015em", margin: "20px 0 18px", maxWidth: 560 }}>
          What your property could earn as a short-let
        </h1>
        <div style={{ fontFamily: SANS, fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>
          {address}, {cityName}<br />{bedrooms} bedrooms · sleeps {guests}
        </div>
      </div>

      <div style={{ margin: "84px 64px 0", paddingTop: 28, borderTop: "1px solid rgba(255,255,255,0.14)", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ fontFamily: SANS, fontSize: 9.5, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.5)" }}>Estimated net income, year one</div>
          <div style={{ fontFamily: SERIF, fontSize: 84, lineHeight: 1.3, letterSpacing: "-0.02em", color: C.tea, marginTop: 8, paddingBottom: 8 }}>{gbp(netTotal)}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontFamily: SANS, fontSize: 9.5, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.5)" }}>Per month</div>
          <span style={{ fontFamily: SERIF, fontSize: 30, lineHeight: 1.3, marginTop: 6, display: "block", paddingBottom: 4 }}>{gbp(avgMonth)}</span>
          <div style={{ fontFamily: SANS, fontSize: 10, lineHeight: 1.55, color: "rgba(255,255,255,0.5)", marginTop: 6 }}>after all fees and VAT</div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", padding: "0 64px 44px", marginTop: 88, fontFamily: SANS, fontSize: 10, color: "rgba(255,255,255,0.5)", lineHeight: 1.6 }}>
        <span>{dateStr}</span>
        <span>Ref {refCode}</span>
      </div>
    </div>
  );
}